import { Component, ErrorHandler, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, FundsPortalService, LocalStorageService } from 'src/app/core/core.module';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';
import { environment } from 'src/environments/environment';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-log-in-page',
  templateUrl: './log-in-page.component.html',
  styleUrls: ['./log-in-page.component.less']
})
export class LogInPageComponent implements OnInit {
  
  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public searchFormGroup!: FormGroup; 

  public openNav: boolean = false;
  public clickOutside: boolean = false;
  public isNotValidInputs: boolean = false;
  public isErrorCompanyCode: boolean = false;
  public isErrorEmail: boolean = false;
  public isErrorPassword: boolean = false;
  public wrongCreds: boolean = false;
  public attemptText: string = '';
  public emailRegex: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';

  constructor(
    private renderer: Renderer2,
    public router: Router,
    public localStorageService: LocalStorageService,
    public fundsPortalService: FundsPortalService,
    public authService: AuthService
  ) { 
    
  }

  ngOnInit(): void {
    if(this.localStorageService.get('bearer') !== null || this.localStorageService.isExpired('bearer')){
      // this.localStorageService.remove('bearer');
      // this.localStorageService.remove('email');
      // this.localStorageService.remove('mobile_number');
      // this.localStorageService.remove('authorized');
      localStorage.clear();
    }
    this.initializeFormGroup();
    this.onChangeValueEmail();
    this.onChangeValuePassword();  
    this.onChangeValueCompanyCode();
  }

  //#region Form Group Events
  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      // expiryDate: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      companyCode: new FormControl('', [Validators.required]),
      pass: new FormControl('', [Validators.required])
    });
  }
  
  onChangeValueEmail(): void {
    const control = this.searchFormGroup.get('email');
    control?.valueChanges.subscribe(value => {
      if (value) {
        this.isErrorEmail = false;

      } else if(!value.valid  && control.touched){

        this.isErrorEmail =true;      
      }
    });
  }

  onChangeValueCompanyCode(): void {
    const control = this.searchFormGroup.get('companyCode');
    control?.valueChanges.subscribe(value => {
      if (value) {
        this.isErrorCompanyCode = false;
      } else if(control?.touched && !value){

        this.isErrorCompanyCode =true;      
      }
    });
  }

  onChangeValuePassword(): void {
    const control = this.searchFormGroup.get('pass');
    control?.valueChanges.subscribe(value => {
      if (value) {
        this.isErrorPassword = false;
      } else if(control?.touched && !value){

        this.isErrorPassword =true;      
      }
    });
  }
  //#region service calls

  proceed(): void {
    var email = this.searchFormGroup.get('email');
    var companyCode = this.searchFormGroup.get('companyCode');
    var password = this.searchFormGroup.get('pass');
    this.wrongCreds = false;
    if (!email?.valid ||
      !companyCode?.valid ||
      !password?.valid) {
        this.isNotValidInputs = true;
        this.isErrorEmail = true;
        this.isErrorCompanyCode = true;
        this.isErrorPassword = true;
        companyCode?.markAsTouched();
        password?.markAsTouched();
        return;
    }
    else{
      this.isNotValidInputs = false;
      this.isErrorEmail = false;
      this.isErrorCompanyCode = false;
      this.isErrorPassword = false;

      this.submit();
    }
  }

   submit(): Promise<any> {
    let body = {  
          email : this.searchFormGroup.get('email')?.value,
          company_code : this.searchFormGroup.get('companyCode')?.value,
          password : this.searchFormGroup.get('pass')?.value
    }

    return new Promise<any>((resolve: any, reject: any) => {
      this.authService.postLogin(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            const token = data['response_data']['token'];
            // intercept locked accounts before granting access
            if (data['response_data']['is_locked'] === true) {
              this.atramModal.show();
              this.atramModal.size = 'sm';
              this.atramModal.status = 'error';
              this.atramModal.headerText = 'Account Locked';
              this.atramModal.bodyText = 'Your account is locked. Please reset your password to regain access.';
              this.atramModal.okButtonText = 'Reset Password';
              this.atramModal.showCancelButton = false;
              this.atramModal.showCloseButton = false;
              this.atramModal.confirmationSubject.subscribe(() => {
                this.atramModal.hide();
                this.router.navigateByUrl('/forgot-password', { skipLocationChange: false });
              });
              return;
            }
            this.localStorageService.set('bearer', token['access_token'], token['expires_in']);
            this.localStorageService.set('email', this.searchFormGroup.get('email')?.value, token['expires_in']);
            this.localStorageService.set('login_company_code', this.searchFormGroup.get('companyCode')?.value, token['expires_in']);
            this.localStorageService.set('mobileNo', token['mobile_number'], token['expires_in']);
            if (data['response_data']['mfa_setup_required'] === true) {
              this.localStorageService.set('enroll_context', 'login', token['expires_in']);
              this.router.navigateByUrl(`/sign-up/email-otp-verify`, { skipLocationChange: false });
            } else {
              this.router.navigateByUrl(`/totp-verify`, { skipLocationChange: false });
            }
            return;
          }
          else if (data['response_result'] === '0004'){
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Login Failed';
            this.atramModal.bodyText = data['response_description'];
            this.atramModal.okButtonText = 'Return';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                this.atramModal.hide();
              });
            return;
          }
        },
        error: error =>{          
          this.wrongCreds = true;
          this.isErrorCompanyCode = true;
          this.isErrorEmail = true;
          this.isErrorPassword = true;
          const responseData = error['response_data'] ?? {};
          if (responseData['is_locked'] === true) {
            this.wrongCreds = false;
            this.attemptText = '';
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Account Locked';
            this.atramModal.bodyText = 'Your account is locked. Please reset your password to regain access.';
            this.atramModal.okButtonText = 'Reset Password';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject.subscribe((confirmation: boolean) => {
              this.atramModal.hide();
              this.router.navigateByUrl('/forgot-password', { skipLocationChange: false });
            });
          } else if (responseData['failed_attempt_count'] !== undefined && responseData['remaining_attempts'] !== undefined) {
            this.attemptText = `${responseData['failed_attempt_count']} failed attempt(s). ${responseData['remaining_attempts']} remaining.`;
          } else {
            this.attemptText = '';
          }
        }
      })
    });
  }

  goToForgotPassword(){
    this.router.navigateByUrl(`/forgot-password`, { skipLocationChange: false });
  }
}


